import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { analytics } from "services/analytics";
import { redactSensitiveParams } from "plg/utils/sensitiveUrl";

export default function TrackPageViews() {
  const location = useLocation();

  useEffect(() => {
    const handleTitleUpdate = () => {
      setTimeout(() => {
        // Explicit, redacted URL fields so Segment/PostHog never record a magic-link ?token=… value.
        const url = redactSensitiveParams(window.location.href);
        analytics.page(document.title || "Unknown Page", {
          hash: location.hash ?? "",
          path: window.location.pathname,
          search: redactSensitiveParams(window.location.search),
          url,
          $current_url: url,
        });
      }, 0);
    };

    handleTitleUpdate();
  }, [location]);

  return null;
}
